import { Twitter, Facebook, Search, Menu, UserRound } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import styles from "./Header.module.css";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import { UiButton, UiSearchInput } from "@/components/ui";
import { UiAvatar } from "@/components/ui/avatar";
import { useAuthStore, useSidebarStore } from "@/context";

export function AvatarSection() {
  const { isAuthenticated, fullname, role, fetchingCurrentUser } =
    useAuthStore();
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.socialAuth}>
        <div className={styles.socialLinks}>
          <a href="#" className={styles.socialLink} aria-label="Twitter">
            <Twitter size={18} />
          </a>
          <a href="#" className={styles.socialLink} aria-label="Facebook">
            <Facebook size={18} />
          </a>
          <a
            href="mailto:contact@senegalservices.com"
            className={styles.socialText}
          >
            @senegalservices
          </a>
        </div>
        {!fetchingCurrentUser && (
          <div>
            {isAuthenticated && (
              <UiAvatar fullname={fullname()} role={role()} />
            )}
            {!isAuthenticated && (
              <div className={styles.authLinks}>
                <Link to="/inscription" className={styles.signupLink}>
                  Inscription
                </Link>

                <UiButton onClick={() => navigate("/connexion")}>
                  CONNEXION
                </UiButton>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

interface navbarProps {
  withNavbar?: boolean;
  withAuth?: boolean;
}

const Header = ({ withNavbar, withAuth = true }: navbarProps) => {
  const { isAuthenticated } = useAuthStore();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const { toggleDashSidebar } = useSidebarStore();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  return (
    <header className={styles.headerContainer}>
      <div
        className={`${styles.headerMain} ${
          withNavbar ? "container" : "container-fluid"
        }`}
      >
        <div className={styles.headerLeft}>
          {isMobile && withNavbar && (
            <button
              className={styles.menuButton}
              onClick={() => setSidebarOpen(!isSidebarOpen)}
              aria-label="Menu"
            >
              <Menu size={24} />
            </button>
          )}

          {!withNavbar && (
            <button
              className={styles.menuButton}
              onClick={toggleDashSidebar}
              aria-label="Menu"
            >
              <Menu size={24} />
            </button>
          )}

          <div className={styles.logoContainer}>
            <Link className="flex gap-4" to="/">
              <img
                src="/assets/images/logosenegal.png"
                alt="Drapeau du Sénégal"
                width={156}
                height={108}
                className={styles.flagImage}
              />
              <img
                src="/assets/images/logo_jourgui.png"
                alt="Jourgui Logo"
                width={184}
                height={188}
                className={styles.logoImage}
              />
            </Link>
            {!isMobile && (
              <div className={styles.sloganText}>
                <p>Une solution innovante pour un cheptel</p>
                <p>prospère au Sénégal</p>
              </div>
            )}
          </div>
        </div>

        <div>
          {isDesktop && (
            <UiSearchInput
              onSubmit={() => {}}
              placeholder="Ex : campagne de vaccination, enquête, ..."
            />
          )}
        </div>

        <div className={styles.headerRight}>
          {isDesktop ? (
            <AvatarSection />
          ) : (
            <div className={styles.mobileIcons}>
              <button className={styles.iconButton} aria-label="Rechercher">
                <Search size={22} />
              </button>
              <Link to="/connexion">
                <button className={styles.iconButton} aria-label="Connexion">
                  <UserRound size={22} />
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>

      <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      {!isMobile && withNavbar && <Navbar />}
    </header>
  );
};

export default Header;
